import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, delay, mergeMap, retryWhen, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AvailabilityService {
    url = environment.apiUrl;
    api_available = new BehaviorSubject<boolean>(true);

    constructor(private http: HttpClient, private toastr: ToastrService) {}

    check() {
        return this.http.post(`${this.url}check`, {}).pipe(
            this.retryWithBackOff(1000, 1),
            tap(res => {}),
            catchError(error => {
                this.api_available.next(false);
                if (error instanceof Error) {
                    // A client-side or network error occurred.7654 Handle it accordingly.
                    console.error('An error occurred:', error);
                    return of(null);
                } else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong,
                    console.error(
                        `Backend returned code ${error.status}, body was: ${error.error}`
                    );
                }

                return error;
            })
        );
    }

    /**
     *
     * @param delayMs delay in ms
     * @param maxRetry Max number of retry
     * @param backoffMs time between retries-
     */
    retryWithBackOff(delayMs: number, maxRetry = 5, backoffMs = 1000) {
        let retries = maxRetry;

        return (src: Observable<any>) =>
            src.pipe(
                retryWhen((errors: Observable<any>) =>
                    errors.pipe(
                        mergeMap(error => {
                            if (retries-- > 0) {
                                if (error == 'Unknown Error') {
                                    console.warn(
                                        'API inacessível. Tentando Novamente.'
                                    );
                                } else {
                                    return throwError('OK');
                                }
                                const backoffTime =
                                    delayMs + (maxRetry - retries) * backoffMs;
                                return of(error).pipe(delay(backoffTime));
                            }
                            return throwError(new Error('MaxRetry Exceeded'));
                        })
                    )
                )
            );
    }
}
